exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.live-share-card{padding:0.51rem\n}\n.live-share-card .img{width:8.65rem;height:13.96rem;border-radius:0.32rem\n}\n.live-share-card__text{text-align:center;font-size:0.4rem;margin-top:0.3rem\n}\n.live-share-card .van-swipe{height:15rem\n}\n.live-share-card .van-swipe__indicator{width:10px;height:10px;border:1px solid #333333;border-radius:50%\n}\n.live-share-card .van-swipe__indicator--active{background-color:#333333;border-color:transparent\n}\n", ""]);

// exports
